import type { AppLocale, LocaleBundle } from "../types";
import { bundleIt } from "./it";
import { bundleEn } from "./en";

export const bundles: Record<AppLocale, LocaleBundle> = {
  it: bundleIt,
  en: bundleEn,
};

export function getBundle(locale: AppLocale): LocaleBundle {
  return bundles[locale] ?? bundleIt;
}
